/* CT Parts Counter — promo-code acknowledgment ribbon (Phase 4, 8/14).
   Locked decision 6: the storefront ACKNOWLEDGES code state; checkout is the
   only calculator. Clear Touch runs promotions OFF-site with Shopify codes —
   a visitor arriving via /discount/CODE?redirect=… must see the code was
   received (Shopify carries even nonexistent codes silently; silence loses
   the sale). /cart.js is the only source of truth; no client-side math.
   Three states (all NEW COPY pending client approval; the empty-cart line is
   a flagged refinement of the locked two-state wording — `applicable` is
   false on ANY empty cart, even for valid codes; verified 8/14):
   — cart has items + applicable:true  → "will be applied at checkout."
   — cart has items + applicable:false → "isn't active for this cart."
   — cart empty                        → "is saved for checkout."
   Zero footprint when no code rides the session. No timers, no percents,
   no summed claims (teardown §3).
   8/14 review fixes: the ribbon re-checks after ANY cart mutation (guarded
   fetch wrapper — Vision's own cart JS never announces its writes), carries
   a sequence token so a stale /cart.js response can't win, and pre-seeds
   from the discount_code cookie at script eval so the band is in the layout
   before first paint on code-carrying visits (kills the CLS). */
(function () {
  'use strict';

  var ribbon = null;
  var seq = 0;

  function ensureRibbon() {
    if (!ribbon) {
      ribbon = document.createElement('div');
      ribbon.className = 'ct-promo-ribbon';
      ribbon.setAttribute('role', 'status');
      document.body.insertBefore(ribbon, document.body.firstChild);
    }
    return ribbon;
  }

  function removeRibbon() {
    if (ribbon && ribbon.parentNode) ribbon.parentNode.removeChild(ribbon);
    ribbon = null;
  }

  function lineFor(code, stateText) {
    var line = document.createElement('p');
    line.className = 'ct-promo-ribbon__line';
    var name = document.createElement('span');
    name.className = 'ct-promo-ribbon__code ct-num';
    name.textContent = code; /* user-controllable via URL — textContent only */
    line.appendChild(document.createTextNode('Code '));
    line.appendChild(name);
    line.appendChild(document.createTextNode(stateText));
    return line;
  }

  function render(codes, hasItems) {
    if (!codes.length) { removeRibbon(); return; }
    var el = ensureRibbon();
    el.innerHTML = '';
    codes.forEach(function (c) {
      var state = !hasItems ? ' is saved for checkout.'
        : c.applicable ? ' will be applied at checkout.'
          : ' isn’t active for this cart.';
      el.appendChild(lineFor(c.code, state));
    });
  }

  function refresh() {
    var t = ++seq;
    fetch('/cart.js')
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (cart) {
        if (t !== seq) return; /* a newer refresh superseded this response */
        var codes = (cart.discount_codes || []).filter(function (c) { return c && c.code; });
        render(codes, cart.item_count > 0);
      })
      .catch(function () { /* cart unreachable — leave the page untouched */ });
  }

  /* Pre-paint seed: Shopify sets a `discount_code` cookie on /discount/CODE
     visits. Reading it synchronously lets the band join the layout before
     first paint; /cart.js then confirms wording (and multi-code state). */
  try {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (m && m[1] && document.body) {
      render([{ code: decodeURIComponent(m[1]), applicable: false }], false);
    }
  } catch (e) { /* cookie unreadable — the fetch path still renders */ }

  /* Vision's cart JS (quantity, remove, code apply) mutates the cart without
     announcing it — observe the network instead. POSTs to the cart mutation
     endpoints trigger a re-check once they settle; /cart.js reads are
     excluded, so no loop. Wrap once, pass through transparently. */
  if (!window.__ctPromoFetchWrapped && window.fetch) {
    window.__ctPromoFetchWrapped = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var target = arguments[0];
      var url = String(target && target.url ? target.url : target || '');
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|update|change|clear)/.test(url)) {
        p.then(function () { setTimeout(refresh, 50); }, function () { /* failed write — state unchanged */ });
      }
      return p;
    };
  }

  document.addEventListener('ct:cart-changed', refresh);
  /* Vision's own document-level cart events (app.js/cart.js dispatch these
     on quantity change, remove and theme-native adds) — second net alongside
     the fetch wrapper. refresh() is idempotent and sequence-guarded. */
  document.addEventListener('line-item:change:end', refresh);
  document.addEventListener('cart:item-added', refresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
